export enum MDSIconKind {
  AlignLeft = "ALIGN_LEFT",
  ArrowLeftToLine = "LEFT_TO_LINE",
  ArrowDownToLine = "DOWN_TO_LINE",
  ArrowRightToLine = "RIGHT_TO_LINE",
  ArrowUpToLine = "UP_TO_LINE",
  ArrowUpFromLine = "UP_FROM_LINE",
  ArrowFromRight = "ARROW_FROM_RIGHT",
  ArrowToRight = "ARROW_TO_RIGHT",
  ArrowUpRight = "ARROW_UP_RIGHT",
  ArrowUpRightFromSquare = "ARROW_UP_RIGHT_FROM_SQUARE",
  ArrowUpArrowDown = "ARROW_UP_ARROW_DOWN",
  ArrowDownTurnLeft = "ARROW_DOWN_TURN_LEFT",
  ArrowRightFromLine = "ARROW_RIGHT_FROM_LINE",
  Expand = "EXPAND",
  Collapse = "COLLAPSE",
  ArrowUp = "ARROW_UP",
  Play = "PLAY",
  PlaySolid = "PLAY_SOLID",
  Pause = "PAUSE",
  PauseSolid = "PAUSE_SOLID",
  SkipForward = "SKIP_FORWARD",
  SkipBackward = "SKIP_BACKWARD",
  Eye = "EYE",
  EyeSlash = "EYE_SLASH",
  Export = "EXPORT",
  Home = "HOME",
  Group = "GROUP",
  Rocket = "ROCKET",
  Flows = "FLOWS",
  Star = "STAR",
  StarSolid = "STAR_SOLID",
  Tag = "TAG",
  Tasks = "TASKS",
  List = "LIST",
  ListCheck = "LIST_CHECK",
  ListTree = "LIST_TREE",
  Bell = "BELL",
  BellSlash = "BELL_SLASH",
  HeadsUp = "HEADS_UP",
  LightbulbOn = "LIGHTBULB_ON",
  Cells = "CELLS",
  Checkbox = "CHECKBOX",
  CheckboxSolid = "CHECKBOX_SOLID",
  CheckboxIndeterminate = "CHECKBOX_INDETERMINATE",
  Check = "CHECK",
  CheckCircleSolid = "CHECK_CIRCLE_SOLID",
  CircleSolid = "CIRCLE_SOLID",
  CircleDot = "CIRCLE_DOT",
  CircleX = "CIRCLE_X",
  CircleExclamation = "CIRCLE_EXCLAMATION",
  CheckboxEmpty = "CHECKBOX_EMPTY",
  Square = "SQUARE",
  Circle = "CIRCLE",
  Clock = "CLOCK",
  History = "CLOCK_ROTATE_LEFT",
  Compass = "COMPASS",
  Copy = "COPY",
  Document = "DOCUMENT",
  Find = "FIND",
  Scribble = "SCRIBBLE",
  Globe = "GLOBE",
  Grip = "GRIP",
  Timeline = "TIMELINE",
  ChartNetwork = "CHART_NETWORK",
  Icons = "ICONS",
  Inbox = "INBOX",
  Trash = "TRASH",
  Settings = "SETTINGS",
  AddPerson = "ADD_PERSON",
  LogOut = "LOG_OUT",
  DesktopApp = "DESKTOP_APP",
  BrandApple = "BRAND_APPLE",
  BrandWindows = "BRAND_WINDOWS",
  PinRight = "PIN_RIGHT",
  UnpinRight = "UNPIN_RIGHT",
  LeftArrow = "LEFT_ARROW",
  RightArrow = "RIGHT_ARROW",
  Calendar = "CALENDAR",
  CalendarCheck = "CALENDAR_CHECK",
  CalendarXmark = "CALENDAR_XMARK",
  Clear = "CLEAR",
  Compose = "COMPOSE",
  ComposeAlt = "COMPOSE_ALT",
  ComposeInline = "COMPOSE_INLINE",
  Message = "MESSAGE",
  MessageSolid = "MESSAGE_SOLID",
  MessageExclamation = "MESSAGE_EXCLAMATION",
  Search = "SEARCH",
  DropdownOpened = "DROPDOWN_OPENED",
  DropdownClosed = "DROPDOWN_CLOSED",
  Envelope = "ENVELOPE",
  EnvelopeOpen = "ENVELOPE_OPEN",
  Envelopes = "ENVELOPES",
  Exit = "EXIT",
  WindowMinimize = "WINDOW_MINIMIZE",
  HandPointRibbon = "HAND_POINT_RIBBON",
  BoxFull = "BOX_FULL",
  AngleRight = "ANGLE_RIGHT",
  AngleLeft = "ANGLE_LEFT",
  AngleUp = "ANGLE_UP",
  AngleDown = "ANGLE_DOWN",
  AngleRightSolid = "ANGLE_RIGHT_SOLID",
  AngleLeftSolid = "ANGLE_LEFT_SOLID",
  AngleUpSolid = "ANGLE_UP_SOLID",
  AngleDownSolid = "ANGLE_DOWN_SOLID",
  Crown = "CROWN",
  Collection = "COLLECTION",
  More = "MORE",
  Merge = "MERGE",
  Minus = "MINUS",
  Plus = "PLUS",
  Reply = "REPLY",
  Replace = "REPLACE",
  Share = "SHARE",
  Shared = "SHARED",
  Sidebar = "SIDEBAR",
  Sparkle = "SPARKLE",
  SparkleOutline = "SPARKLE_OUTLINE",
  UniqueSparkle = "UNIQUE_SPARKLE",
  Cleanup = "CLEANUP",
  Bolt = "BOLT",
  Palette = "PALETTE",
  CreditCard = "CREDIT_CARD",
  Upvote = "UPVOTE",
  Downvote = "DOWNVOTE",
  UpvoteSolid = "UPVOTE_SOLID",
  DownvoteSolid = "DOWNVOTE_SOLID",
  Send = "SEND",
  SendAlt = "SEND_ALT",
  Wifi = "WIFI",
  WifiSlash = "WIFI_SLASH",
  CloudSlash = "CLOUD_SLASH",
  CloudArrowDown = "CLOUD_ARROW_DOWN",
  CloudArrowUp = "CLOUD_ARROW_UP",
  CloudArrowDownSolid = "CLOUD_ARROW_DOWN_SOLID",
  CloudArrowUpSolid = "CLOUD_ARROW_UP_SOLID",
  CloudExclamation = "CLOUD_EXCLAMATION",
  CloudExclamationSolid = "CLOUD_EXCLAMATION_SOLID",
  CloudSlashFlipped = "CLOUD_SLASH_FLIPPED",
  LinkSolid = "LINK_SOLID",
  Link = "LINK",
  Loader = "LOADER",
  Lock = "LOCK",
  LockSolid = "LOCK_SOLID",
  Bookmark = "BOOKMARK",
  BookmarkSolid = "BOOKMARK_SOLID",
  Menu = "MENU",
  Redo = "REDO",
  Book = "BOOK",
  Warning = "WARNING",
  Experimental = "EXPERIMENTAL",
  Sort = "SORT",
  SortAlt = "SORT_ALT",
  Help = "HELP",
  Question = "QUESTION",
  Sorted = "SORTED",
  Spinner = "SPINNER",
  SpinnerSolid = "SPINNER_SOLID",
  SpinnerThird = "SPINNER_THIRD",
  Exclamation = "EXCLAMATION",
  ExclamationSolid = "EXCLAMATION_SOLID",
  Danger = "DANGER",
  Pen = "PEN",
  Ban = "BAN",
  Shapes = "SHAPES",
  User = "USER",
  UserSolid = "USER_SOLID",
  Image = "IMAGE",
  Gif = "GIF",
  Film = "FILM",
  GalleryThumbnails = "GALLERY_THUMBNAILS",
  Code = "CODE",
  CodeBlock = "CODE_BLOCK",
  Quote = "QUOTE",
  QuoteRight = "QUOTE_RIGHT",
  Pdf = "PDF",
  PhoneSms = "PHONE_SMS",
  Phone = "PHONE",
  Keyboard = "KEYBOARD",
  Import = "IMPORT",
  H1 = "H1",
  H2 = "H2",
  H3 = "H3",
  Bold = "BOLD",
  Italic = "ITALIC",
  Underline = "UNDERLINE",
  Strikethrough = "STRIKETHROUGH",
  NumberedList = "NUMBERED_LIST",
  RemoveFormat = "REMOVE_FORMAT",
  Table = "TABLE",
  Paperclip = "PAPERCLIP",
  Dot = "DOT",
  Pipe = "PIPE",
  InfoCircle = "INFO_CIRCLE",
  Notebook = "NOTEBOOK",
  Thumbtack = "THUMBTACK",
  ThumbtackSolid = "THUMBTACK_SOLID",
  Heart = "HEART",
  HeartSolid = "HEART_SOLID",
  GearCode = "GEAR_CODE",
  CalendarDay = "CALENDAR_DAY",
  HorizontalRule = "HORIZONTAL_RULE",
  Radar = "RADAR",
  Laptop = "LAPTOP",
  Mobile = "MOBILE",
  Robot = "ROBOT",
  Template = "TEMPLATE",
  EmptyDocument = "EMPTY_DOCUMENT",
  Filter = "FILTER",
  BoltOutline = "BOLT_OUTLINE",
  LogoZapier = "LOGO_ZAPIER",
  LogoZapierSquare = "LOGO_ZAPIER_SQUARE",
  LogoFireflies = "LOGO_FIREFLIES",
  LogoTypeform = "LOGO_TYPEFORM",
  LogoSlack = "LOGO_SLACK",
  RegularMicrophone = "REGULAR_MICROPHONE",
  Microphone = "MICROPHONE",
  MicrophoneAlt = "MICROPHONE_SOLID",
  MicrophoneSlash = "MICROPHONE_SLASH",
  TextSlash = "TEXT_SLASH",
  Comment = "COMMENT",
  Folder = "FOLDER",
  Clipboard = "CLIPBOARD",
  Window = "WINDOW",
  File = "FILE",
  FileAlt = "FILE_ALT",
  Waveform = "WAVEFORM",
  WaveformLines = "WAVEFORM_LINES",
  Video = "VIDEO",
  ExternalLink = "EXTERNAL_LINK",
  Flask = "FLASK",
  CircleMinus = "CIRCLE_MINUS",
  SplitPanel = "SPLIT_PANEL",
  PuzzlePiece = "PUZZLE",
  GoogleChrome = "GOOGLE_CHROME",
  Chrome = "CHROME",
  CaretRight = "CARET_RIGHT",
  CaretDown = "CARET_DOWN",
  CaretUp = "CARET_UP",
  Brand = "BRAND",
  BrandHover = "BRAND_HOVER",
  BrandTransparent = "BRAND_TRANSPARENT",
  Logo = "LOGO",
  ArrowBrand = "ARROW_BRAND",
  RotateRight = "ROTATE_RIGHT",
  Moon = "MOON",
  Telescope = "TELESCOPE",
  CopySolid = "COPY_SOLID",
  Refresh = "REFRESH",
  AutoOrganize = "AUTO_ORGANIZE",
  CalendarEvent = "CALENDAR_EVENT",
  GoogleCalendar = "GOOGLE_CALENDAR",
  OutlookCalendar = "OUTLOOK_CALENDAR",
  GoogleMeetMed = "GOOGLE_MEET_MED",
  GoogleMeetSmall = "GOOGLE_MEET_SMALL",
  ZoomMed = "ZOOM_MED",
  ZoomSmall = "ZOOM_SMALL",
  Mcp = "MCP",
  Slack = "SLACK",
  Teams = "TEAMS",
  WhatsApp = "WHATSAPP",
  Anthropic = "ANTHROPIC",
  OpenAI = "OPENAI",
  GoogleGemini = "GOODLEGEMINI",
  Text = "TEXT",
  Browser = "BROWSER",
  BrowserSlash = "BROWSER_SLASH",
  OCR = "OCR",
  SunBright = "SUN_BRIGHT",
  Desktop = "DESKTOP",
}

export enum MDSIconColor {
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
  Placeholder = "PLACEHOLDER",
  OnAccent = "ON_ACCENT",
  Brand = "BRAND",
  Selected = "SELECTED",
  Emphasis = "EMPHASIS",
  Danger = "DANGER",
  Positive = "POSITIVE",
  OnChromeInactive = "ON_CHROME_INACTIVE",
  Inherit = "INHERIT",
}

export interface MDSIconProps extends React.HTMLAttributes<HTMLDivElement> {
  kind: MDSIconKind;
  size?: number;
  boxSize?: number;
  color?: MDSIconColor;
  overrideColor?: string; // Not intended to be used by anything other than CollectionIcon
}

export type MDSIconFunction = ({
  size,
  boxSize,
  color,
}: {
  size: number;
  boxSize: number;
  color: MDSIconColor;
}) => React.ReactNode;
